module.exports = __webpack_public_path__ + "static/nm-serif.df546f7f.woff2";